import { gql } from '@apollo/client';

export const NEW_MATERIAL_UNIT = gql`
  fragment NewMaterialUnit on MaterialUnit {
    id
  }
`;
